
exports.AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR'
exports.CONNECTION_ERROR = 'CONNECTION_ERROR'
exports.INVALID_DATABASE_ERROR = 'INVALID_DATABASE_ERROR'
exports.TIMEOUT_ERROR = 'TIMEOUT_ERROR'
exports.INVALID_AUTHORIZATION_SPECIFICATION = 'INVALID_AUTHORIZATION_SPECIFICATION'
exports.ACCESS_DENIED_ERROR = 'ACCESS_DENIED_ERROR'



//////////////////
// WEBPACK FOOTER
// ../~/@segment/db-connect/constants.js
// module id = 1039
// module chunks = 0